<template>
  <modal-layout :is-open="isOpen" @close="closeModal()">
    <div class="Modal_area">
      <div
        class="Modal__cross-box _cross"
        role="button"
        tabindex="0"
        aria-label="クラス詳細モーダルを閉じる"
        @click="closeModal()"
      >
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner">
        <div v-if="scheduleDetail">
          <div class="Modal_schedule">
            {{ handleDateToDay(scheduleDetail.date) }} {{ scheduleDetail.learning_time }}～
            <div class="Label Label__time Modal__label_time">
              {{ scheduleDetail.time }}分
            </div>
          </div>
          <div v-if="isOngoingClass" class="Modal_ongoing">
            <div v-if="scheduleDetail.is_canceled" class="Modal_ongoing_canceled">
              <img src="/assets/img/icon_calendar.png" alt="icon" class="Modal_ongoing_canceled_icon">
              <span class="Modal_ongoing_canceled_tx">本日休講</span>
            </div>
            <router-link v-else to="/zoom-setup" tag="div" class="Modal_ongoing_btn">
              <img src="/assets/img/icon_login.png" alt="icon" class="Modal_ongoing_btn_icon">
              <span class="Modal_ongoing_btn_tx">Zoomに入室する</span>
            </router-link>
          </div>
          <div class="Modal_schedule_main">
            <div class="Modal_class_badges">
              <div
                class="Modal_class_category_name"
                :style="'background-color: ' + scheduleDetail.master_program_category.c_background_color"
              >
                {{ scheduleDetail.master_program_category.category_name }}
              </div>
              <div v-if="scheduleDetail.is_canceled" class="Modal_class_canceled">
                <img src="/assets/img/icon_calendar.png" alt="icon" class="Modal_class_canceled_icon">
                <span class="Modal_class_canceled_tx">休講</span>
              </div>
              <div v-else-if="scheduleDetail.is_recorded" class="Modal_class_recorded">
                <img src="/assets/img/icon_recorded_white.png" alt="icon" class="Modal_class_recorded_icon">
                <span class="Modal_class_recorded_tx">録画配信</span>
              </div>
            </div>
            <div class="Modal_class_info">
              <div class="Modal_class_name">
                <img
                  class="Modal_class_icon"
                  :src="scheduleDetail.master_program_category.c_icon_url"
                  alt="icon"
                >
                {{ scheduleDetail.class }}
              </div>
              <div
                :class="`Modal_class_favorite_btn ${isCategotyFavorite ? '_active' : ''}`"
                @click="changeCategoryFavorite(scheduleDetail.class_category)"
              />
            </div>
            <div class="Modal_class_description">
              <!-- eslint-disable vue/no-v-html -->
              <p v-html="scheduleDetail.master_program_category.description" />
              <!-- eslint-enable -->
              <div v-if="scheduleDetail.detail_url" class="Modal_class_detail_url">
                <a class="Modal_class_detail_url_link" :href="scheduleDetail.detail_url" target="_blank">
                  クラス詳細を見る
                </a>
                <img src="/assets/img/icon_arrow_right.png" alt="icon" class="Modal_class_detail_url_icon">
              </div>
            </div>
            <div class="Modal_class_instructor">
              <div class="Modal_class_instructor_head">
                担当インストラクター
              </div>
              <div class="Modal_class_instructor_info">
                <img :src="showAvatar(scheduleDetail.master_instructor)" alt="icon" class="Modal_class_instructor_img">
                <div class="Modal_class_instructor_name">
                  {{ scheduleDetail.master_instructor ? scheduleDetail.master_instructor.name : '' }}
                </div>
                <div
                  :class="`Modal_class_favorite_btn ${isInstructorFavorite ? '_active' : ''}`"
                  @click="changeInstructorFavorite(scheduleDetail.instructor)"
                />
              </div>
            </div>
            <div class="Modal_notice">
              <label :class="`Check__box _ft-spacing60 ${isDisable ? '_disabled' : ''}`">
                <input v-model="scheduleDetail.is_favorite_class" :disabled="isDisable" type="checkbox" name="checkbox01" @click="changeClassFavorite(scheduleDetail.id)">
                <span :disabled="isDisable" class="Check__box_inner" />
                開始 {{ timeNoti }}分前に通知する
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import { mapState } from 'vuex'
import ModalLayout from '@/views/components/modals/ModalLayout'
import scheduleService from '@/services/scheduleService'
import favoriteService from '@/services/favoriteService'
import moment from 'moment'
import { convertAvatar } from '@/helpers'
import userDetailService from '@/services/authService'

export default {
  name: 'ModalSchedule',
  components: { ModalLayout },
  data() {
    return {
      isOpen: false,
      scheduleDetail: {
        master_program_category: {
          name: ''
        }
      },
      isCategotyFavorite: false,
      isInstructorFavorite: false,
      timeNoti: 10,
      isDisable: false
    }
  },
  computed: {
    ...mapState({
      scheduleId: state => state.modal.modalScheduleId,
      isOngoingClass: state => state.modal.isOngoingClass,
      isLogin: state => state.user.isLogin
    })
  },
  watch: {
    scheduleId(value) {
      if (value > 0) {
        scheduleService.show(value).then((detail) => {
          const date = moment(detail.data.date).local()
          detail.data.learning_time = date.format('HH:mm')
          this.scheduleDetail = detail.data
          this.isCategotyFavorite = this.scheduleDetail.is_favorite_category
          this.isInstructorFavorite = this.scheduleDetail.is_favorite_instructor
          this.isDisable = (moment(detail.data.date) <= moment()) || Boolean(this.scheduleDetail.is_canceled)
          this.isOpen = true
        }).catch(error => {
          console.log(error)
        })
      } else {
        this.isOpen = false
      }
    }
  },
  mounted() {
    this.timeNotiAfter()
  },
  methods: {
    closeModal() {
      this.$store.commit('modal/setModalSchedule', 0)
    },
    handleDateToDay(date) {
      return moment(date).locale('ja').format('MMMDo(ddd)')
    },
    changeInstructorFavorite(instructorId) {
      if (this.isLogin) {
        this.isInstructorFavorite = !this.isInstructorFavorite
        favoriteService.addInstructorFavorite(instructorId)
        this.$emit('change')
      } else {
        window.location.href = '/signin'
      }
    },
    changeCategoryFavorite(categoryId) {
      if (this.isLogin) {
        this.isCategotyFavorite = !this.isCategotyFavorite
        favoriteService.addCategoryFavorite(categoryId)
        this.$emit('change')
      } else {
        window.location.href = '/signin'
      }
    },
    changeClassFavorite(id) {
      if (this.isLogin) {
        favoriteService.addClassFavorite(id)
      } else {
        window.location.href = '/signin'
      }
    },
    redirectClass() {
      this.$store.dispatch('modal/openModalSchedule', 0)
      window.location.href = '/class'
    },
    showAvatar(instructor) {
      let url = null
      if (instructor) {
        url = instructor.image_url
      }
      return convertAvatar(url)
    },
    async timeNotiAfter() {
      if (this.isLogin) {
        const response = await userDetailService.getUserInfo()
        if (response && response.user && response.user.user) {
          const userDetail = {
            displayName: response.user.user.display_name
          }
          sessionStorage.setItem('user-detail', JSON.stringify(userDetail))
          this.timeNoti = response.user.user.time_before_received_class_start_notification
        }
      }
    }
  }

}
</script>
